import { render, staticRenderFns } from "./ObkDescriptionCanceledCardsNoteStep.vue?vue&type=template&id=1faf475c&scoped=true"
import script from "./ObkDescriptionCanceledCardsNoteStep.vue?vue&type=script&lang=js"
export * from "./ObkDescriptionCanceledCardsNoteStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf475c",
  null
  
)

export default component.exports